module.exports = __webpack_public_path__ + "img/step_2-2.35f82be9.png";